import Sortable from 'sortablejs';
import surveyModel from "../../models/survey/survey.model";
import ViewBase from "../view-base.view";
import SurveyCategoryView from "./survey-category.view";
import SurveyQuestionsListView from './survey-questions-list.view';

export default function SurveyCategoryMasterView() {
  ViewBase.call(this);
  let onSaveComplete = () => { };
  let questionTypes = [];
  let isQsView = false;
  let surveyId = "";
  let surveyIdString = "";
  let surveyType = '';
  let iconList = [];
  let selectedSubSurvey = { questions: [] };
  let inputFilter = [];
  let maxQnId = 0;

  let createGuid = () => {
    return Math.floor(Math.random() * 1000000);//generate in between 0 and 1000000
  }

  let _getQuestions = (id) => {
    this.showLoading();
    return surveyModel.getQuestions(id)
      .then((result) => {
        this.hideLoading();
        if (result == null) {
          _addSurvey();
        }
        else {
          _manageinputQuestions(result);
        }
      })
      .catch((error) => {
        this.hideLoading();
        if (error.code == 401) {
          this.showMessage(this.getText("LT00000292", "Session Expired. Please login and try again."));
        }
      });
  }

  let _manageinputQuestions = (result) => {
    inputFilter = _generateSurvey(result);

  }

  let _generateSurvey = (sList) => {
    let sur = [];
    sList.forEach(function (item) {
      let sc = {
        name: item.category == null ? "" : item.category,
        expand: false,
        surveyId: createGuid(),
        subSurvey: _generateSubSurvey(item.subCategoryList)

      };
      sur.push(sc);
    });
    return sur;
  }

  let _generateSubSurvey = (sList) => {
    let sur = [];
    sList.forEach(function (item) {
      let sc = {
        name: item.subCategory == null ? "" : item.subCategory,
        subSurveyId: createGuid(),
        questions: _generateQuestionList(item.questionList),

      };
      sur.push(sc);
    });
    return sur;
  }

  let _generateQuestionList = (sList) => {
    let sur = [];
    sList.forEach(function (item) {
      let parentQ = { code: "", name: "" };
      let parentOp = { code: "", name: "" };
      if (item.parentQuestionId != 0) {
        let pQ = sList.filter(x => x.questionId == item.parentQuestionId);
        if (pQ.length > 0) {
          parentQ = { code: pQ[0].questionId.toString(), name: pQ[0].questionText };
          let pO = pQ[0].optionList.filter(x => x.optionId == item.parentOptionId);
          if (pO.length > 0) {
            parentOp = { code: pO[0].optionId.toString(), name: pO[0].optionText };
          }
        }
      }
      let sc = {
        code: item.questionId.toString(),
        questiontext: item.questionText,
        questionType: { code: item.questionTypeCode.toString(), name: item.questionType },
        sequence: item.dispSeq,
        mandatory: { code: item.mandatoryYN, name: item.mandatoryYN == "N" ? "No" : "Yes" },
        usedYN: { code: "Y", name: "Yes" },
        parentQuestion: parentQ,
        parentAnsId: parentOp,
        optionList: _generateOptionList(item.optionList),
        photoGuid: item.fileMasterId == null ? "" : item.fileMasterId,
        photoNumberLimit: { code: item.photoNumberLimit.toString(), name: item.photoNumberLimit.toString() },
        ratingWordsMax: item.ratingWordsMax,
        ratingWordsMin: item.ratingWordsMin,
        questionHint: item.questionHint,
        minValue: item.minValue,
        maxValue: item.maxValue
      };
      sur.push(sc);
    });
    return sur;
  }

  let _generateOptionList = (sList) => {
    let sur = [];
    sList.forEach(function (item) {
      let sc = {
        qid: item.surveyQuestionId.toString(),
        code: item.optionId.toString(),
        name: item.optionText,
        sequence: item.dispSeq
      };
      sur.push(sc);
    });
    return sur;
  }

  let _getSurveyById = () => {
    surveyModel.getSurveyDetails(
      (result) => {
        surveyType = result.surveyType;
        _getQuestionTypes(surveyType);
      }, (error) => {
        if (error.code == 401) {
          this.showMessage(this.getText("LT00000292", "Session Expired. Please login and try again."));
        }
      }, surveyId);
  }

  let _getQuestionTypes = (type) => {
    surveyModel.getQuestionTypes(
      (result) => {
        questionTypes = result;
        iconList = [];
        result.forEach((item) => {
          if (item.code == "0001")//text
            iconList.push({ code: item.code, icon: "", color: "#1E85F1", text: "T", textIcon: "" });
          if (item.code == "0002")//Singlr
            iconList.push({ code: item.code, icon: "", color: "#191C25", text: "S", textIcon: "" });
          if (item.code == "0003")//Multiple
            iconList.push({ code: item.code, icon: "", color: "#8A8DA0", text: "M", textIcon: "" });
          if (item.code == "0004")//Photo
            iconList.push({ code: item.code, icon: "", color: "#84E0BE", text: "P", textIcon: "" });
          if (item.code == "0005")// Number
            iconList.push({ code: item.code, icon: "", color: "#F9AC19", text: "N", textIcon: "" });
          if (item.code == "0006")//Date
            iconList.push({ code: item.code, icon: "", color: "#FA4942", text: "D", textIcon: "" });
          if (item.code == "0007")//GPS
            iconList.push({ code: item.code, icon: "", color: "#F38068", text: "G", textIcon: "" });
          if (item.code == "0008")//Single Dropdown
            iconList.push({ code: item.code, icon: "", color: "#F38068", text: "S", textIcon: "bi-arrow-down" });
          if (item.code == "0009")//Multi Dropdown
            iconList.push({ code: item.code, icon: "", color: "#5BB971", text: "M", textIcon: "bi-arrow-down" });
          if (item.code == "0010")//Barcode
            iconList.push({ code: item.code, icon: "", color: "#B79D63", text: "B", textIcon: "" });
          if (item.code == "0011")//YesNo
            iconList.push({ code: item.code, icon: "", color: "#A69DB9", text: "Y", textIcon: "" });
          if (item.code == "0012")//Rating
            iconList.push({ code: item.code, icon: "", color: "#96CAFE", text: "R", textIcon: "" });
        });



      }, (error) => {
        //console.log("error:"+error);
        if (error.code == 401) {
          this.showMessage(this.getText("LT00000292", "Session Expired. Please login and try again."));
          //m.route.set("/login");
        }
      }, type);
  }

  let _addSurvey = () => {
    let survey = {
      name: "",
      expand: false,
      surveyId: createGuid(),
      subSurvey: [
        {
          name: "",
          subSurveyId: createGuid(),
          questions: [],
        }
      ]
    };
    inputFilter.push(survey);
  }

  let onDeleteSurvey = (sur) => {
    let items = inputFilter.filter(x => x.surveyId != sur.surveyId);
    inputFilter = items;
  }

  let _onbeforeunload = (e) => {
    e.preventDefault();
    e.stopPropagation();
    return confirm("Confirm refresh");
  }

  return {
    oninit: function (vnode) {
      window.onbeforeunload = function (event) {
        return confirm("Confirm refresh");
      };
      if (vnode.attrs.surveyId) {
        surveyId = vnode.attrs.surveyId;
        surveyId.replace(' ', '+');
        _getSurveyById();
        _getQuestions(surveyId);
      }
      if (vnode.attrs.surveyIdString) {
        surveyIdString = vnode.attrs.surveyIdString;
      }
      if (vnode.attrs.onSaveComplete) {
        onSaveComplete = vnode.attrs.onSaveComplete;
      }
    },
    onremove: function (vnode) {
      window.onbeforeunload = null;
    },
    oncreate: function (vnode) {
      const surveyQsMList = document.getElementById("surveyQsM");
      new Sortable(surveyQsMList, {
          animation: 150,
          ghostClass: 'sortable-ghost',
          dragClass: 'sortable-drag',
          handle: '.drag-grip',
      });
      window.addEventListener("onbeforeunload", _onbeforeunload);
    },
    view: (vnode) => {
      return [
        !isQsView &&
        m(SurveyCategoryView,
          {
            onQuestionClicked: (subSurvey, maxId) => {
              maxQnId = maxId;
              selectedSubSurvey = subSurvey;
              isQsView = true;
            },
            onDelete: (sur) => {
              onDeleteSurvey(sur);
            },
            onSaveComplete: () => {
              onSaveComplete();
            },
            surveyViewState: vnode.attrs.surveyViewState,
            survey: inputFilter,
            surveyId: surveyId,
            surveyIdString: surveyIdString
          },
        ),
        isQsView &&
        m(SurveyQuestionsListView,
          {
            surveyType,
            subSurvey: selectedSubSurvey,
            questionTypeList: questionTypes,
            iconList: iconList,
            maxQnId: maxQnId,
            surveyIdString: surveyIdString,
            onClosed: () => {
              isQsView = false;
            },
            onAdd: (obj) => {
              //[Thilanka]Keep this line of codes for future references.May be this function will activate again
              // let arr=selectedSubSurvey.questions.map(x=>x.code);
              // let max=selectedSubSurvey.questions.length==0?1:(Math.max.apply(null,arr)+1);
              // obj["code"]=max.toString();
              selectedSubSurvey.questions.push(obj);
            },
            onDelete: (index) => {
              //[Thilanka]Keep this line of codes for future references.May be this function will activate again
              //let sortArr = [];
              selectedSubSurvey.questions.splice(index, 1);
              // selectedSubSurvey.questions.map(function (element, index) {
              //   element["sequence"] = index + 1;
              // });
              //selectedSubSurvey.questions=sortArr;
            },
            onEdit: (index, obj, oldSequence) => {
              if (obj.sequence != oldSequence.toString()) {
                let item = selectedSubSurvey.questions.filter(x => x.sequence == obj.sequence);
                if (item.length == 1) {
                  item[0].sequence = oldSequence;
                }
              }
              selectedSubSurvey.questions[index] = obj;
            }
          }
        ),
        this.getBaseViews()
      ];
    }
  }
}
